import { NgModule } from '@angular/core';
import { RadSelectDirective } from './rad-select.directive';

@NgModule({
  declarations: [RadSelectDirective],
  exports: [RadSelectDirective]
})
export class RadSelectModule { }
